export const LEADS_LIST_FILTERS = 'leads-list-filters';

/**
 * The access token. Deliberately localStorage and not a cookie.
 *
 * Browsers cap a cookie at 4096 bytes of name + value and discard anything
 * larger *silently* — `document.cookie` returns nothing and throws nothing.
 * Our access token is a JWT carrying the user's entire `permissions` array
 * (see `createToken` in server.core.authenticator), so it grows with the number
 * of roles on the account: one heavy role is already ~4.0 KB and two put it
 * past 4.7 KB. Those users had the cookie dropped on write while the
 * 36-character `refresh-token` beside it stored fine, so the app looked signed
 * in until a second tab asked storage for a token and found nothing.
 *
 * localStorage has no such ceiling (~5 MB), is scoped to the origin and is
 * shared across tabs — which is all the cookie was ever doing here. Nothing
 * server-side or in nginx reads `user-token`; the API is called with an
 * `Authorization: Bearer` header.
 *
 * The key keeps its old `user-token` name so it stays recognisable in
 * DevTools → Application, just under Local Storage instead of Cookies.
 */
export const USER_ACCESS_TOKEN_KEY = 'user-token';
